

















































































































































































































import { Vue, Component } from 'vue-property-decorator';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import { enums } from '@/common/enums';
import { formRules } from '@/common/util/validator';
import AddressSelect from '@/components/AddressSelect.vue';
import { ShipManagementApi,Carrier } from '@/http';
import { type } from '@/http/interface';
import publicFunc from '../../common/util/publicFunc';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        DataPanel,
        SearchPanel,
        PaginationPanel,
        DraggerImg,
        collapse,
        ListFilterPanel,
        AddressSelect,
    },
})
export default class ConsigneeShipperManagement extends Vue {

    public publicFunc = publicFunc;

    public searchValue: type.GetShipperListPayload = {
        name: '',
        contactName:'',
        isEnabled: null,
        startTime: '',
        endTime: '',
        asc: null,
        orderBy: ''
    };
    public timeList = [];

    public title: string = '新增收发货方';

    public dialogVisible: boolean = false;

    public formRules = formRules;

    public shipStateType = enums.shipStateType;

    public isActive: boolean = false;

    public loading: boolean = false;

    public rePagin: boolean = false;

    public total: number = 0;

    public tableData:any = [];

    public formData: type.AddOrEditShipperVM = {
        name: '',
        shipperType: null,
        code: '',
        contactName: '',
        contactPhone: '',
        province: '',
        city: '',
        county: '',
        detail: '',
        isEnabled: false,
        remark: '',
    };


    public selectReset = false;

    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
        formData: HTMLFormElement;
        address: HTMLFormElement;
    };

    public created() {
        this.selectReset = true;
    }
    public mounted() {
        if (sessionStorage.getItem('ConsigneeShipperManagement_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('ConsigneeShipperManagement_searchValue'));
            this.timeList = [this.searchValue.startTime, this.searchValue.endTime];
            this.searchPagin = sessionStorage.getItem('ConsigneeShipperManagement_page')
                ? JSON.parse(sessionStorage.getItem('ConsigneeShipperManagement_page'))
                : this.searchPagin;

            this.loadData();
        } else {
            this.searchPagin = sessionStorage.getItem('ConsigneeShipperManagement_page')
                ? JSON.parse(sessionStorage.getItem('ConsigneeShipperManagement_page'))
                : this.searchPagin;

            this.loadData();
        }
    }
    public colData = JSON.parse(localStorage.getItem('ConsigneeShipperManagement'))
        ? JSON.parse(localStorage.getItem('ConsigneeShipperManagement'))
        : [
              { title: '企业名称', isShow: true, disabled: false },
              { title: '企业编码', isShow: true, disabled: false },
              { title: '收发货人', isShow: true, disabled: false },
              { title: '联系人手机号', isShow: true, disabled: false },
              { title: '地址', isShow: true, disabled: false },
              { title: '状态', isShow: true, disabled: false },
              { title: '创建人', isShow: true, disabled: false },
              { title: '创建时间', isShow: true, disabled: false },
          ];
    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('ConsigneeShipperManagement_searchValue', JSON.stringify(this.searchValue));
    }

    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('ConsigneeShipperManagement_page', JSON.stringify(pagin));
        this.loadData();
    }

    public handleCheckedChange() {
        let newDate = this.colData.filter((item) => item.isShow == false);
        if (this.colData.length - newDate.length == 3) {
            this.$message.warning('至少选择3个');
            this.colData.forEach((item) => {
                if (item.isShow) {
                    item.disabled = true;
                }
            });
        } else {
            this.colData.forEach((item) => {
                item.disabled = false;
            });
        }
        localStorage.setItem('ConsigneeShipperManagement', JSON.stringify(this.colData));
    }

    public async loadData() {
        this.loading = true;
        try {
          let skip = this.searchPagin.skip; 
          let res = await ShipManagementApi.GetList({
                ...this.searchValue,
                skip: skip,
                count: this.searchPagin.count
            });
            this.tableData = res.data;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch (error) {
            this.loading = false;
        }
    }

    public sort(col): void {
        if (col.order == 'ascending') {
            this.searchValue.asc = true;
        } else {
            this.searchValue.asc = false;
        }
        switch (col.prop) {
            case 'creationTime':
                {
                    this.searchValue.orderBy = 1;
                }
                break;
        }
        this.loadData();
    }

    public datetimerange(v) {
        if (v) {
            this.searchValue.startTime = v[0];
            this.searchValue.endTime = v[1];
        } else {
            this.searchValue.startTime = null;
            this.searchValue.endTime = null;
        }
    }
    public resetSearchValue() {
        this.searchValue = {
            name: '',
            contactName:'',
            isEnabled: null,
            startTime: '',
            endTime: '',
            asc: null,
            orderBy: ''
        };
         this.searchFunc();
    }

    public handleClose() {
        this.dialogVisible = false;
    }
    public async updateReset() {
        this.selectReset = false;
    }

    public SelectAddress = {
        province: {
            value: '',
            text: '',
        },
        city: {
            value: '',
            text: '',
        },
        area: {
            value: '',
            text: '',
        },
    };
    public async getProvince(item, name) {
        this.formData.province = item;
        // this.formData.province = name;
    }

    public async getCityCode(item, name) {
        this.formData.city = item;
    }

    public async getAreaCode(item, name) {
        this.formData.county = item;
    }
  
    public save() {
        let address = this.$refs.address.validateForm();
        this.$refs.formData.validate(async (valid) => {
            if (address&&valid) {
                if(this.title == '新增收发货方'){
                    let formData =Object.assign({},this.formData);
                    ShipManagementApi.Add(formData).then(res=>{
                        this.$message.success('新增成功!');
                        this.loadData();
                        this.dialogVisible = false;
                    })
                }else{
                    let formData =Object.assign({},this.formData);
                    ShipManagementApi.Edit(this.formData.id,formData).then(res=>{
                        this.$message.success('编辑成功!');
                        this.loadData();
                        this.dialogVisible = false;
                    })
                }
                
            }
        });
    }



   async addbtn() {
        this.title = '新增收发货方';
            this.formData = {
            name: '',
            shipperType: null,
            code: '',
            contactName: '',
            contactPhone: '',
            province: '',
            city: '',
            county: '',
            detail: '',
            isEnabled: true,
            remark: '',
        };
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }
        this.dialogVisible = true;
    }

    async toEdit(id:string) {
        this.title = '编辑收发货方';
        this.selectReset = false;
        let data:any = await ShipManagementApi.GetDetail(id);
        if(data.province&&data.province!=''){
                this.SelectAddress.province.value = data.province;
                this.SelectAddress.city.value = data.city;
                this.SelectAddress.area.value = data.county;
        }else{
        this.SelectAddress = {
                province: {
                    value: '',
                    text: '',
                },
                city: {
                    value: '',
                    text: '',
                },
                area: {
                    value: '',
                    text: '',
                },
            };
        }
      
        this.formData = data;
        this.selectReset = true;
        if (this.$refs.formData) {
            this.$refs.formData.resetFields();
            this.$refs.address.clear();
        }
        this.dialogVisible = true;
    }
    public dialogConfig = {
        title: '',
        show: false,
    };
    confirmClose() {
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }
    confirmOk() {
        ShipManagementApi.Delete(this.id).then((res) => {
            this.$message.success('删除成功');
            this.loadData();
        });
        this.dialogConfig = {
            title: '',
            show: false,
        };
    }

    public id:string = '';

    toDel(id) {
        this.id = id;
        this.dialogConfig = {
            title: '删除',
            show: true,
        };
    }
    handleInput(e, index) {
        e.target.value =  e.target.value=e.target.value.replace(/[^\d]/g,'');
        this.formData.contactPhone = e.target.value;
    }
}
